import { DemographicBreakdownSegment } from '../../types/debt.type';
import tailwindConfig from '../../../tailwind.config';

interface SegmentButtonProps {
  segment: DemographicBreakdownSegment;
  isSelected: boolean;
  colour: string;
  onClick: () => void;
}

export default function SegmentButton({
  segment, isSelected, colour, onClick,
}: SegmentButtonProps) {
  return (
    <button
      type="button"
      className={`w-full flex items-center justify-between px-3 py-5 rounded-md border text-left transition-colors ${
        isSelected
          ? 'bg-primary/10 border-primary'
          : 'bg-white border-pipgrey-border hover:bg-pipbg-grouped'
      }`}
      onClick={onClick}
    >
      <div className="flex items-center gap-2.5">
        <span
          className={`shrink-0 w-4 h-4 rounded-full border transition-colors ${
            isSelected ? 'bg-pipbg-subtle' : ''
          }`}
          style={{
            backgroundColor: isSelected ? tailwindConfig.theme.extend.colors.pieChart.slice1 : colour,
            borderColor: isSelected ? colour : 'transparent',
          }}
        />
        <span className="text-sm text-secondary font-normal">{segment.displayName}</span>
      </div>
      <span className="text-sm text-secondary font-normal">
        {segment.averageDebt}
      </span>
    </button>
  );
}
